import React from 'react';
import Table from '../../lib/ui/components/table/Table';

/**
 * Full-width table skeleton for page-level loading (roles list, job details, etc.).
 */
const PageLoader = ({ skeletonRowCount = 6 }) => (
    <div className="mx-4 mt-2 w-[calc(100%-2rem)] max-w-full overflow-hidden rounded-lg border border-gray-200 bg-white">
        <div className="overflow-x-auto">
            <Table className="min-w-full">
                <Table.Head>
                    {['Role', 'Status', 'Updated', 'Actions'].map((label) => (
                        <Table.HeadCell key={label}>{label}</Table.HeadCell>
                    ))}
                </Table.Head>
                <Table.Body loading skeletonRowCount={skeletonRowCount} />
            </Table>
        </div>
    </div>
);

export default PageLoader;
